import Button from './components/Button';
import ProfileView from './ProfileView'
import { useEffect } from 'react';
import { motion } from 'framer-motion';

export function ProfileContainer(props: any) {

    useEffect(() => {
        //window.scrollTo(0, 0);

    }, [])


    return (
        <ProfileView memberCode={props.memberCode} />

    )
}